
import jQuery from "jquery";
window.$ = window.jQuery = jQuery;

import validate from 'jquery-validation';

import AOS from 'aos'; //? https://github.com/michalsnik/aos




// | ------------------------------------------------------------------------
// | Template Components
// | ------------------------------------------------------------------------ 


// Header
import './components/fixedHeader';
import './components/scrollLinks';

import './components/parallax';

// Navigation
//import './components/menuDropdownHover';
//import './components/mobileSelectNav';
//import './components/mobileMenu';

// Content
import './components/imageLazyLoad';
//import './components/quantityInput';
//import './components/productGallery';

import './components/formValidation';


// | ------------------------------------------------------------------------

window.addEventListener('load', (event) => {
    AOS.init();   // not sure why this doesn't work in an imported file...
});


var $parallaxElement = $('.parallax-bg');
var elementHeight = $parallaxElement.outerHeight();

function parallax() {
 
  var scrollPos = $(window).scrollTop();
  var transformValue = scrollPos/40;
  var opacityValue =  1 - ( scrollPos / 1000);
  var blurValue = Math.min(scrollPos / 100, 3);
  
  if ( scrollPos < elementHeight ) {
  
    $parallaxElement.css({
      'transform': 'translate3d(0, -' + transformValue + '%, 0)',
      'opacity': opacityValue,
      '-webkit-filter' : 'blur('+blurValue+'px)'
    });
    
  }
  
}

$(window).scroll(function() {
  parallax();
});


